import {
  getAdvertisersFromClients,
  getAdvertisersFromWhitelabels,
  sortAdvertisersByLabels,
} from '@/helpers/advertisers';
import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { selectHideWhitelabels } from './me.selectors';
import {
  selectRibeyeWithBeeswaxClients,
  selectRibeyeWithBeeswaxWhitelabels,
  selectSharedApiLoading,
} from './sharedApi.selectors';

export const selectSegments = (state: RootState) => state.segments;

export const selectSegmentsSegments = createSelector([selectSegments], ({ segments, segmentsRequestId }) => ({
  segments,
  loadingSegments: !!segmentsRequestId,
}));

export const selectSelectedSegment = createSelector(
  [selectSegments],
  ({ selectedSegment, selectedSegmentRequestId }) => ({
    selectedSegment,
    loadingSelectedSegment: !!selectedSegmentRequestId,
  }),
);

export const selectSegmentsFilters = createSelector([selectSegments], ({ filters }) => filters);

export const selectSegmentsAdvertisers = createSelector(
  [selectRibeyeWithBeeswaxWhitelabels, selectRibeyeWithBeeswaxClients, selectSharedApiLoading, selectHideWhitelabels],
  (whitelabels, clients, loading, hideWhitelabels) => {
    if (loading) {
      return [];
    }
    const advertisers = hideWhitelabels
      ? getAdvertisersFromClients(clients || [])
      : getAdvertisersFromWhitelabels(whitelabels || []);

    return sortAdvertisersByLabels(advertisers);
  },
);

export const selectSegmentsCreatives = createSelector(
  [selectSegments],
  ({ creatives, creativesRequestId, creativesTotal, creativeFilters }) => ({
    creatives,
    loadingCreatives: !!creativesRequestId,
    total: creativesTotal,
    creativeFilters,
  }),
);
